import { dataTypesAllowedInMultiDivisionDropdown } from '../../../forms.constants';
import { DYNAMIC_ATTRIBUTE_LINK_MAP } from '../Attribute.helpers';

export default {};

export const getAttributeTypes = (t, {
  isMultiDivisionForm = false,
  isTimeCard = false,
} = {}) => {
  const types = [
    { value: 'projects', label: t('Projects') },
    { value: 'equipment', label: 'Equipment' },
    { value: 'customers', label: 'Customers' },
    { value: 'users', label: 'Users' },
    // Support these later
    // { value: 'costcodes', label: 'Cost Codes' },
  ];

  if (isTimeCard) return types.filter(({ value }) => value === 'users');

  if (!isMultiDivisionForm) return types;

  return types.filter(({ value }) => (
    dataTypesAllowedInMultiDivisionDropdown.has(DYNAMIC_ATTRIBUTE_LINK_MAP[value])
  ));
};

export const INVALID_TYPES = new Set([
  'attachment',
  'staticAttachments',
  'multiSig',
  'payment',
  'table',
  'weather',
]);

export const isAllowedDynamicAttributeType = (attributeType) => (
  dataTypesAllowedInMultiDivisionDropdown.has(DYNAMIC_ATTRIBUTE_LINK_MAP[attributeType])
);
